import React, { useState, useEffect, useCallback } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "./Table.css";

type TableProps = {
  tableRows: {
    [row: string]: string;
  }[];
  removeId?: boolean;
  bordered?: boolean;
  hover?: boolean;
  excludeKeys?: string[];
  pagination?: number;
  children?: React.ReactNode;
  handleSelect?: (
    row?: any,
    isSelected?: boolean,
    rowIndex?: number,
    e?: React.SyntheticEvent<Element, Event>
  ) => boolean | void;
};

export const Table: React.FunctionComponent<TableProps> = ({
  tableRows,
  excludeKeys,
  pagination,
  handleSelect,
}) => {
  const [activeTableRows, setActiveTableRows] = useState([]);
  const [activeColumns, setActiveColumns] = useState([]);

  const createColumns = (columnData) => {
    const tableData = [];
    Object.keys(columnData[0]).forEach((key) => {
      if (key !== "id") {
        tableData.push({
          dataField: key,
          text: key,
        });
      }
    });
    setActiveColumns(tableData);
  };

  const removeTableRowItems = () => {
    const filteredValues = tableRows?.reduce((accumulator, currentValue) => {
      for (const [key, value] of Object.entries(currentValue)) {
        if (excludeKeys.includes(key) && key !== "id") {
          delete currentValue[key];
        }
      }

      accumulator.push(currentValue);
      return accumulator;
    }, []);
    if (filteredValues && filteredValues.length > 0) {
      setActiveTableRows(filteredValues);
      createColumns(filteredValues);
    }
    return filteredValues;
  };

  useEffect(() => {
    if (excludeKeys.length === 0) {
      setActiveTableRows(tableRows);
    } else if (tableRows) {
      removeTableRowItems();
    }
  }, [excludeKeys]);

  useEffect(() => {}, [tableRows]);

  const options = {
    sizePerPage: pagination,
    paginationSize: 4,
    pageStartIndex: 1,
    showTotal: true,
    selectRow: true,
    sizePerPageList: [
      {
        text: pagination,
        value: pagination,
      },
      {
        text: pagination * 2,
        value: pagination * 2,
      },
      {
        text: "All",
        value: activeTableRows.length,
      },
    ],
  };

  return (
    <div className="table">
      {activeTableRows && activeColumns.length > 0 && (
        <BootstrapTable
          keyField="id"
          data={activeTableRows}
          columns={activeColumns}
          pagination={paginationFactory(options)}
          selectRow={{
            mode: "radio",
            hideSelectColumn: true,
            clickToSelect: true,
            bgColor: "#f9fcff",
            onSelect: handleSelect,
          }}
        />
      )}
    </div>
  );
};
